module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_9016.89d48446.png";